interface Args {
  id: string;
  admin: string;
  amount: string;
  uuid: string;
}
interface SelectedAssets {
  [key: string]: {
    [key: string]: boolean;
  };
}
export const getSelectedAssets = (rows: Args[]) => {
  const selected = {} as SelectedAssets;
  rows.forEach((r) => {
    if (selected[r.admin]) {
      selected[r.admin][r.id] = true;
    } else {
      selected[r.admin] = { [r.id]: true };
    }
  });
  return selected;
};
